import { uniq } from 'lodash';
import { getPortfolioConfig } from 'platform-components/src/components/app-factory/selectors';
import { createSelector } from 'reselect';

import { PROJECTS } from './constants';

export const getActiveProjects = createSelector([getPortfolioConfig], (portfolioConfig) => {
    return portfolioConfig?.active_projects;
});

export const getConfigSlugs = createSelector([getPortfolioConfig], (portfolioConfig) => {
    return portfolioConfig?.cert_slugs;
});

// Получаем набор старых слогов за ивенты, которые открывались по условию
// TODO: выпилить - https://st.yandex-team.ru/EDUCATION-28552
export const getOldEventsWithConditionSlugsFromConfig = createSelector(
    [getActiveProjects, getConfigSlugs],
    (activeProjects, configSlugs) => {
        if (activeProjects?.includes(PROJECTS.EVENTS) && configSlugs?.[PROJECTS.EVENTS]) {
            return configSlugs[PROJECTS.EVENTS];
        }

        return [];
    }
);

// Получаем набор старых слогов за ивенты, которые открывались без условий
// TODO: выпилить - https://st.yandex-team.ru/EDUCATION-28552
export const getOldEventsWithoutConditionSlugsFromConfig = createSelector(
    [getActiveProjects, getConfigSlugs],
    (activeProjects, configSlugs) => {
        if (activeProjects?.includes(PROJECTS.WEBINAR_EVENTS) && configSlugs?.[PROJECTS.WEBINAR_EVENTS]) {
            return configSlugs[PROJECTS.WEBINAR_EVENTS];
        }

        return [];
    }
);

// Получаем слаги сертов за ивенты, которые доступны по условию
export const getEventsWithConditionSlugsFromConfig = createSelector(
    [getActiveProjects, getConfigSlugs],
    (activeProjects, configSlugs) => {
        if (activeProjects?.includes(PROJECTS.EVENTS_WITH_CONDITION) && configSlugs?.[PROJECTS.EVENTS_WITH_CONDITION]) {
            return configSlugs[PROJECTS.EVENTS_WITH_CONDITION];
        }

        return [];
    }
);

// идентичные сертификаты за ивенты, которые выдаются по коду без доп условий
export const getEventsWithoutConditionSlugsFromConfig = createSelector(
    [getActiveProjects, getConfigSlugs],
    (activeProjects, configSlugs) => {
        if (
            activeProjects?.includes(PROJECTS.EVENTS_WITHOUT_CONDITION) &&
            configSlugs?.[PROJECTS.EVENTS_WITHOUT_CONDITION]
        ) {
            return configSlugs[PROJECTS.EVENTS_WITHOUT_CONDITION];
        }

        return [];
    }
);

// Получаем слаги вебинаров за ивенты, которые доступны по условию
export const getWebinarsWithConditionSlugsFromConfig = createSelector(
    [getActiveProjects, getConfigSlugs],
    (activeProjects, configSlugs) => {
        if (
            activeProjects?.includes(PROJECTS.WEBINARS_WITH_CONDITION) &&
            configSlugs?.[PROJECTS.WEBINARS_WITH_CONDITION]
        ) {
            return configSlugs[PROJECTS.WEBINARS_WITH_CONDITION];
        }

        return [];
    }
);

// идентичные сертификаты за вебинары, которые выдаются по коду без доп условий
export const getWebinarsWithoutConditionSlugsFromConfig = createSelector(
    [getActiveProjects, getConfigSlugs],
    (activeProjects, configSlugs) => {
        if (
            activeProjects?.includes(PROJECTS.WEBINARS_WITHOUT_CONDITION) &&
            configSlugs?.[PROJECTS.WEBINARS_WITHOUT_CONDITION]
        ) {
            return configSlugs[PROJECTS.WEBINARS_WITHOUT_CONDITION];
        }

        return [];
    }
);

// различные сертификаты, которые выдаются по коду без доп условий
export const getCertsWithoutConditionSlugsFromConfig = createSelector(
    [getActiveProjects, getConfigSlugs],
    (activeProjects, configSlugs) => {
        if (
            activeProjects?.includes(PROJECTS.CERTS_WITHOUT_CONDITION) &&
            configSlugs?.[PROJECTS.CERTS_WITHOUT_CONDITION]
        ) {
            return configSlugs[PROJECTS.CERTS_WITHOUT_CONDITION];
        }

        return [];
    }
);

// слаги всех сертов за ивенты
export const getAllEventSlugsFromConfig = createSelector(
    [
        getEventsWithConditionSlugsFromConfig,
        getEventsWithoutConditionSlugsFromConfig,
        getOldEventsWithConditionSlugsFromConfig,
    ],
    (eventSlugsWithCondition, eventSlugsWithoutCondition, oldEventSlugsWithCondition) =>
        uniq([...eventSlugsWithCondition, ...eventSlugsWithoutCondition, ...oldEventSlugsWithCondition])
);

// слаги всех сертов за вебинары
export const getAllWebinarSlugsFromConfig = createSelector(
    [
        getWebinarsWithConditionSlugsFromConfig,
        getWebinarsWithoutConditionSlugsFromConfig,
        getOldEventsWithoutConditionSlugsFromConfig,
    ],
    (webinarSlugsWithCondition, webinarSlugsWithoutCondition, oldEventSlugsWithoutCondition) =>
        uniq([...webinarSlugsWithCondition, ...webinarSlugsWithoutCondition, ...oldEventSlugsWithoutCondition])
);

// слаги всех сертов с условиями
export const getAllCertSlugsWithConditionFromConfig = createSelector(
    [
        getEventsWithConditionSlugsFromConfig,
        getWebinarsWithConditionSlugsFromConfig,
        getOldEventsWithConditionSlugsFromConfig,
    ],
    (eventSlugsWithCondition, webinarSlugsWithCondition, oldEventSlugsWithCondition) =>
        uniq([...eventSlugsWithCondition, ...webinarSlugsWithCondition, ...oldEventSlugsWithCondition])
);

// слаги всех сертов без условий
export const getAllCertSlugsWithoutConditionFromConfig = createSelector(
    [
        getEventsWithoutConditionSlugsFromConfig,
        getWebinarsWithoutConditionSlugsFromConfig,
        getOldEventsWithoutConditionSlugsFromConfig,
        getCertsWithoutConditionSlugsFromConfig,
    ],
    (eventSlugsWithoutCondition, webinarSlugsWithoutCondition, oldEventSlugsWithoutCondition, certsWithoutConditions) =>
        uniq([
            ...eventSlugsWithoutCondition,
            ...webinarSlugsWithoutCondition,
            ...oldEventSlugsWithoutCondition,
            ...certsWithoutConditions,
        ])
);
